var keys = {
    APP_inbox_title: "APP_inbox_title",
    APP_inbox_step1: "APP_inbox_step1",
    APP_inbox_step2: "APP_inbox_step2",
    APP_inbox_step3: "APP_inbox_step3",
    APP_inbox_bullet1: "APP_inbox_bullet1",
    APP_inbox_bullet2: "APP_inbox_bullet2",
    APP_inbox_termsTitle: "APP_inbox_termsTitle",
    APP_redirectTitle: "APP_redirectTitle",
    APP_redirectBody: "APP_redirectBody",
    APP_redirectWhatsHappening: "APP_redirectWhatsHappening",
    APP_redirectBulletNowLabel: "APP_redirectBulletNowLabel",
    APP_redirectBulletNowText: "APP_redirectBulletNowText",
    APP_redirectBulletSoonLabel: "APP_redirectBulletSoonLabel",
    APP_redirectBulletSoonText: "APP_redirectBulletSoonText",
    APP_redirectFooter: "APP_redirectFooter",
    APP_redirectContinue: "APP_redirectContinue",
    APP_redirectGoToNew: "APP_redirectGoToNew",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ3BDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxvQkFBb0IsRUFBRSxzQkFBc0I7SUFDNUMsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLGdCQUFnQixFQUFFLGtCQUFrQjtJQUNwQywwQkFBMEIsRUFBRSw0QkFBNEI7SUFDeEQsMEJBQTBCLEVBQUUsNEJBQTRCO0lBQ3hELHlCQUF5QixFQUFFLDJCQUEyQjtJQUN0RCwyQkFBMkIsRUFBRSw2QkFBNkI7SUFDMUQsMEJBQTBCLEVBQUUsNEJBQTRCO0lBQ3hELGtCQUFrQixFQUFFLG9CQUFvQjtJQUN4QyxvQkFBb0IsRUFBRSxzQkFBc0I7SUFDNUMsbUJBQW1CLEVBQUUscUJBQXFCO0NBQzNDLENBQUM7QUFFRixlQUFlLElBQUksQ0FBQyJ9